import React from "react";
import { initializeIcons } from "@fluentui/react/lib/Icons";
import { registerIcons } from "@fluentui/react/lib/Styling";
import { initializeIcons as initializeIconsFabric } from "office-ui-fabric-react/lib/Icons";
import { registerIcons as registerIconsFabric } from "office-ui-fabric-react/lib/Styling";
import {
  SaveIcon,
  UndoIcon,
  ChevronRightIcon,
  ChevronDownIcon,
  MiniExpandIcon,
  MiniContractIcon
} from "@fluentui/react-icons-mdl2";

const iconBaseUrl = `${window.location.origin}/fabric-icons/`;

initializeIcons(iconBaseUrl);
initializeIconsFabric(iconBaseUrl);

const customIcons = {
  icons: {
    Save: <SaveIcon />,
    Undo: <UndoIcon />,
    ChevronRight: <ChevronRightIcon />,
    ChevronDown: <ChevronDownIcon />,
    MiniExpand: <MiniExpandIcon />,
    MiniContract: <MiniContractIcon />
  }
};

registerIcons(customIcons);
registerIconsFabric(customIcons);
